/**
 * Ссылки в Telegram. На компьютере открываем приложение Telegram напрямую (tg://),
 * а не сайт t.me: 12.10 у Тимофея на Windows t.me не открылся (ERR_CONNECTION_TIMED_OUT),
 * а Telegram Desktop по tg:// — открылся. Формат — из документации Telegram (Deep links).
 */

/** https://t.me/<бот>[/<приложение>]?startapp=X → tg://resolve?domain=<бот>[&appname=…]&startapp=X; не t.me — пусто. */
export function telegramAppLink(link: string): string {
  let u: URL;
  try {
    u = new URL(link);
  } catch {
    return "";
  }
  if (u.protocol !== "https:" || !["t.me", "telegram.me"].includes(u.hostname)) return "";
  const [bot, app] = u.pathname.split("/").filter(Boolean);
  if (!bot) return "";
  const q = new URLSearchParams({ domain: bot });
  if (app) q.set("appname", app);
  const start = u.searchParams.get("startapp");
  if (start) q.set("startapp", start);
  return `tg://resolve?${q.toString()}`;
}

/** Телефон или планшет: там t.me сам открывает приложение Telegram. */
export function isMobileBrowser(ua: string = navigator.userAgent): boolean {
  return /Android|iPhone|iPad|iPod|Mobile/i.test(ua);
}

/** Открыть ссылку входа: на компьютере — приложение Telegram, на телефоне — t.me. */
export function openTelegramLink(link: string): "app" | "web" {
  const app = telegramAppLink(link);
  if (app && !isMobileBrowser()) {
    window.location.href = app; // браузер спросит «Открыть Telegram?», страница остаётся
    return "app";
  }
  window.open(link, "_blank", "noopener,noreferrer");
  return "web";
}
